import { armor_charge_clicked, change_sandbox, set_stat, change_activity } from "./interface_functions.js"
import * as change_images from "./changing_images.js"
import { update_tooltip } from "./update_tooltip.js"
import { character, menu_manager, commander } from "./singletons.js"
import { Armor } from "./complex_effect.js"
//import { navigate } from "./slide_menu.js"


function customSort(a, b)
{
    if (a.startsWith("empty") && !b.startsWith("empty"))
    {
        return -1; // Если строка a начинается с "empty", а строка b - нет, то a идёт раньше
    }
    else if (!a.startsWith("empty") && b.startsWith("empty"))
    {
        return 1; // Если строка b начинается с "empty", а строка a - нет, то b идёт раньше
    }
    else
    {
        return a.localeCompare(b); // Иначе сравниваем строки по алфавиту
    }
}

console.log('APP/MAIN: Status==active');

var images = new Array();

Object.keys(change_images.subclass_id_to_class_img).forEach(
    (key) => {
        var img = new Image();
        img.loading = 'eager';
        img.src = change_images.subclass_id_to_class_img[key];
        img.style.display = 'none';
        document.querySelector('body').appendChild(img);
        images.push(img);
    }
)

menu_manager.screen_size_change();

if (localStorage.getItem('gamemode') === null)
{
    character.set_sandbox('pvp');
    document.getElementById('sandbox_switch').checked = true;
    localStorage.setItem('gamemode', 'pvp');
}
else
{
    if (localStorage.getItem('gamemode') == 'pvp')
    {
        character.set_sandbox('pvp');
        document.getElementById('sandbox_switch').checked = true;
        document.documentElement.setAttribute('data-gamemode', 'pvp');
    }
    else
    {
        character.set_sandbox('pve');
        document.getElementById('sandbox_switch').checked = false;
        document.documentElement.setAttribute('data-gamemode', 'pve');
    }
}

//.getElementById("loading-image-1").classList.remove("grid-img");
//document.getElementById("loading-image-1").classList.add("grid-img-visible");

window.addEventListener("resize", (event) => menu_manager.screen_size_change());

try
{
    screen.orientation.addEventListener(
        "change",
        (event) =>
        {
          menu_manager.menu.hide();
          menu_manager.tooltip.hide();
        }
    );
}
catch (error)
{
    window.addEventListener(
        "resize",
        (event) =>
        {
          menu_manager.menu.hide();
          menu_manager.tooltip.hide();
        }
    );
}

//document.getElementById("loading-image-2").classList.remove("grid-img");
//document.getElementById("loading-image-2").classList.add("grid-img-visible");

let class_id = 'titan';

if (localStorage.getItem('class_id') !== null)
    class_id = localStorage.getItem('class_id');

let element_id = 'solar';

if (localStorage.getItem('element_id') !== null)
    element_id = localStorage.getItem('element_id');


character.element = element_id;

window.menu_manager = menu_manager;
window.character = character;

/// handlers
document.getElementById("armor_charge_button_row").addEventListener(
    "click",
    (event) =>
    {
        console.log(event.target);
        if (event.target.matches('.armor_charge_button')) {
            armor_charge_clicked(parseInt(event.target.getAttribute("data-armor-charge-button-number")));
        }
    }
);

window.change_sandbox = change_sandbox;
window.set_stat = set_stat;
window.change_activity = change_activity;

try
{
    //let dateNow = Date.now();
    const response = await fetch("/manifest_data");

    console.log("resp", response)

    if (!response.ok)
    {
        const text = await response.text();
        throw Error(text);
    }

    const result = await response.json();

    // add effects to storage
    character.set_data(result['classes']);
    character.set_data(result['subclasses']);
    character.set_data(result['supers']);
    character.set_data(result['aspects']);
    character.set_data(result['fragments']);
    character.set_data(result['melees']);
    character.set_data(result['grenades']);
    character.set_data(result['class_abilities']);
    character.set_data(result['exotic_weapons']);
    character.set_data(result['effects']);
    character.set_data(result['perks']);
    character.set_data(result['dummies']);
    character.set_array_data(result['activities']);

    character.set_data(
        {
            "dummy_helmet": new Armor("dummy_helmet", character, "helmet", "head"),
            "dummy_gauntlets": new Armor("dummy_gauntlets", character, "gauntlets", "arms"),
            "dummy_chest_armor": new Armor("dummy_chest_armor", character, "chest_armor", "chest"),
            "dummy_leg_armor": new Armor("dummy_leg_armor", character, "leg_armor", "legs"),
            "dummy_class_armor": new Armor("dummy_class_armor", character, "class_armor", "class"),
        },
        true
    );

    /*
        Dummies
    */

    character.dummy_stats = character.get_effect("major_stats_dummy");
    character.effects.inc_counter("major_stats_dummy");

    character.dummy_weapon_stats = character.get_effect("weapon_stats_dummy");
    character.effects.inc_counter("weapon_stats_dummy");

    for (let class_id in result['classes'])
        character.set_data(result['exotic_armor'][class_id]);

    for (let mod_slot in result['armor_mods'])
    {
        console.log("mod slot", mod_slot);
        character.set_data(result['armor_mods'][mod_slot]);
    }

    character.plugInSocket("empty_exotic_weapon_slot", "exotic_weapon",  0, false);
    character.plugInSocket("dummy_helmet", "helmet", 0, false);
    character.plugInSocket("dummy_gauntlets", "gauntlets", 0, false);
    character.plugInSocket("dummy_chest_armor", "chest_armor", 0, false);
    character.plugInSocket("dummy_leg_armor", "leg_armor", 0, false);
    character.plugInSocket("dummy_class_armor", "class_armor", 0, false);

    //binding sockets to menu_manager slots

    menu_manager.addSlot(
    "super_ability",
        { socketCategory: "super_ability", socketIndex: 0, masterItem: character },
        { buttonId: "super_ability_button", buttonGroup: "ability_button_group", buttonHighlighterId: "super_ability_button_selected" },
        []
    );

    menu_manager.addSlot(
        "class_ability",
        { socketCategory: "class_ability", socketIndex: 0, masterItem: character },
        { buttonId: "class_ability_button", buttonGroup: "ability_button_group", buttonHighlighterId: "class_ability_button_selected" },
        []
    );

    menu_manager.addSlot(
        "grenade_ability",
        { socketCategory: "grenade_ability", socketIndex: 0, masterItem: character },
        { buttonId: "grenade_ability_button", buttonGroup: "ability_button_group", buttonHighlighterId: "grenade_ability_button_selected" },
        []
    );

    menu_manager.addSlot(
        "melee_ability",
        { socketCategory: "melee_ability", socketIndex: 0, masterItem: character },
        { buttonId: "melee_ability_button", buttonGroup: "ability_button_group", buttonHighlighterId:"melee_ability_button_selected"  },
        []
    );

    menu_manager.addSlot(
        "aspect",
        { socketCategory: "aspect", socketIndex: 0, masterItem: character },
        { buttonId: "aspect_button_0", buttonGroup: "aspect_button_group", buttonHighlighterId: "aspect_button_0_selected" },
        []
    );

    menu_manager.addSlot(
        "aspect",
        { socketCategory: "aspect", socketIndex: 1, masterItem: character },
        { buttonId: "aspect_button_1", buttonGroup: "aspect_button_group", buttonHighlighterId: "aspect_button_1_selected" },
        []
    );

    for (let i = 0; i < 6; i++)
    {
        menu_manager.addSlot(
            "fragment",
            { socketCategory: "fragment", socketIndex: i, masterItem: character },
            { buttonId: `fragment_button_${i}`, buttonGroup: "fragment_button_group", buttonHighlighterId: `fragment_button_${i}_selected` },
            []
        );
    }

    menu_manager.addSlot(
        "exotic_armor",
        { socketCategory: "exotic_armor", socketIndex: 0, masterItem: character },
        { buttonId: "exotic_armor_button", buttonGroup: "exotic_button_group", buttonHighlighterId: "exotic_armor_button_selected" },
        []
    );

    menu_manager.addSlot(
        "exotic_weapon",
        { socketCategory: "exotic_weapon", socketIndex: 0, masterItem: character },
        { buttonId: "exotic_weapon_button", buttonGroup: "exotic_button_group", buttonHighlighterId: "exotic_weapon_button_selected" },
        []
    );

    menu_manager.updateSlotSelection("exotic_weapon", 0, Object.keys(result['exotic_weapons']).sort(customSort));

    for (let [armorCategory, armorSlot, index] of [["helmet", "head", 0], ["gauntlets", "arms", 1], ["chest_armor", "chest", 2], ["leg_armor", "legs", 3], ["class_armor", "class", 4]])
    {
        let armorSocketKey = character.sockets.categories[armorCategory][0];
        let armorSocket = character.sockets.entries[armorSocketKey];
        let armorPiece = character.get_effect(armorSocket.get_current());

        armorPiece.plugInSocket("empty_general_armor_mod", "general_armor_mod", 0, false);

        menu_manager.addSlot(
            "general_armor_mod",
            { socketCategory: "general_armor_mod", socketIndex: 0, masterItem: armorPiece },
            { buttonId: `general_armor_mod_button_${index}`, buttonGroup: `${armorSlot}_armor_mods_button_group`, buttonHighlighterId: `general_armor_mod_button_${index}_selected` },
            []
        );

        menu_manager.updateSlotSelection("general_armor_mod", index, Object.keys(result['armor_mods']["general"]).sort(customSort));

        for (let i = 0; i < 3; i++)
        {
            armorPiece.plugInSocket(`empty_${armorSlot}_armor_mod`, `${armorSlot}_armor_mod`, i, false);

            menu_manager.addSlot(
                `${armorSlot}_armor_mod`,
                { socketCategory: `${armorSlot}_armor_mod`, socketIndex: i, masterItem: armorPiece },
                { buttonId: `${armorSlot}_armor_mod_button_${i}`, buttonGroup: `${armorSlot}_armor_mods_button_group`, buttonHighlighterId: `${armorSlot}_armor_mod_button_${i}_selected` },
                []
            );

            menu_manager.updateSlotSelection(`${armorSlot}_armor_mod`, i, Object.keys(result['armor_mods'][armorSlot]).sort(customSort));
        }
    }

    for (let activity of result['activities'])
    {
        console.log('new activity', activity,  activity.id);
        let option = new Option(activity.display_properties.name, activity.id);
        option.setAttribute('data-sandbox', activity.sandbox);
        activity_select.options.add(option);
    }
    commander.update(
        {
            update_type: "update_activity_select_list",
            sandbox: character.sandbox,
        }
    );

    character.traits = result['traits'];

    commander.exec_command(
        {
            command_type: "set_effect",
            effect_id: class_id,
            effect_type: "class",
        }
    );

    document.getElementById("loading-screen").classList.add("loading-screen-hidden");
    console.log("loading finished", document.getElementById("loading-screen"))

}
catch (error)
{
    console.log(error);
}

